import React from 'react';

const YoutubeSlider = () => {
  return <div>YoutubeSlider</div>;
};

export default YoutubeSlider;
